import type { enNotifications } from '../en/notifications';

export const idNotifications: Record<keyof typeof enNotifications, string> = {
  'notifications.title': 'Notifikasi',
  'notifications.open': 'Notifikasi',
  'notifications.openUnread': 'Notifikasi, {count} belum dibaca',
  'notifications.markAllRead': 'Tandai semua sudah dibaca',
  'notifications.empty':
    'Belum ada yang baru. Persetujuan, kiriman, dan permintaan yang perlu Anda tangani muncul di sini.',
  'notifications.loadError': 'Notifikasi tidak dapat dimuat.',
  'notifications.unreadDot': 'Belum dibaca',
  'notifications.otherBranch': 'Dibuka di {branch}',
  'notifications.kind.approval.pending': '{label} menunggu persetujuan Anda ({step}, {amount}).',
  'notifications.kind.approval.approved': '{label} telah disetujui.',
  'notifications.kind.approval.rejected': '{label} ditolak.',
  'notifications.kind.receipt.posted': 'Barang untuk {po} sudah diterima ({gr}).',
  'notifications.kind.receipt.exceptions':
    '{gr} memiliki barang yang ditahan untuk diperiksa (baris: {count}).',
  'notifications.kind.receipt.emergency_review': 'Pembelian darurat {gr} perlu Anda tinjau.',
  'notifications.kind.requisition.pending_approval':
    'Permintaan stok {number} menunggu persetujuan Anda.',
  'notifications.kind.requisition.ready_to_pick':
    'Permintaan stok {number} sudah disetujui dan siap diambil.',
  'notifications.kind.requisition.rejected': 'Permintaan stok {number} Anda ditolak.',
  'notifications.kind.requisition.issued':
    'Permintaan stok {number} Anda sudah dikeluarkan. Konfirmasi saat barang tiba.',
  'notifications.kind.stock.low': 'Barang di bawah titik pesan ulang: {count}.',
  'notifications.kind.ap.due':
    'Tagihan pemasok lewat jatuh tempo: {overdue}; jatuh tempo dalam {days} hari: {dueSoon}.',
};
